/* Copyright (c) 2023 CLOUDPILOTS Software & Consulting GmbH */

import React from 'react';
import './app.css';
import Content from './content';
import Home from './home';
import ProviderStack from './provider-stack';

function App() {
  return (
    <ProviderStack>
      <Content>
        <Home />
      </Content>
    </ProviderStack>
  );
}

export { App as default };
